import React from 'react';
interface CardProps {
  className?: string;
  children: React.ReactNode;
}
export const Card = ({
  className = '',
  children
}: CardProps) => {
  return <div className={`rounded-lg border bg-card text-card-foreground shadow-sm ${className}`} data-id="element-172">
      {children}
    </div>;
};
export const CardHeader = ({
  className = '',
  children
}: CardProps) => {
  return <div className={`flex flex-col space-y-1.5 p-6 ${className}`} data-id="element-173">
      {children}
    </div>;
};
export const CardTitle = ({
  className = '',
  children
}: CardProps) => {
  return <h3 className={`text-lg font-semibold leading-none tracking-tight ${className}`} data-id="element-174">
      {children}
    </h3>;
};
export const CardContent = ({
  className = '',
  children
}: CardProps) => {
  return <div className={`p-6 pt-0 ${className}`} data-id="element-175">{children}</div>;
};